import { render, staticRenderFns } from "./urgent.vue?vue&type=template&id=ff936450&scoped=true"
import script from "./urgent.vue?vue&type=script&lang=js"
export * from "./urgent.vue?vue&type=script&lang=js"
import style0 from "./urgent.vue?vue&type=style&index=0&id=ff936450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff936450",
  null
  
)

export default component.exports